module.exports = __webpack_public_path__ + "img/pexels-anna-shvets-3727464.ab416f3f.jpg";